<template>
  <div>
    <div class="card w-100">
      <div class="card-body">
        <h5 class="card-title mb-4">Calculadora de Lucro de Trade Esportivo</h5>
        <div class="row">
          <div class="col-12 mt-3" style="text-align:center">
            <b-form-group label="Minha entrada foi em: " v-slot="{ ariaDescribedby }">
              <b-form-radio-group
                v-model="selected"
                :options="options"
                :aria-describedby="ariaDescribedby"
                name="plain-inline"
                plain
              ></b-form-radio-group>
            </b-form-group>
          </div>
          <div class="col-12 col-md-6 mt-3">
            <div class="button-gradient-yellow" style="width: 190px;">
              <label>Odd Back:</label>
            </div>
            <money
              v-model="oddBack"
              :keyup="verifyOddBack(oddBack)"
              v-bind="odd"
              class="form-control input-format-grey"
              style="padding-left:200px;"
            />
          </div>
          <div class="col-12 col-md-6 mt-3">
            <div class="button-gradient-yellow" style="width: 150px;">
              <label>Odd Lay:</label>
            </div>
            <money
              v-model="oddLay"
              :keyup="verifyOddLay(oddLay)"
              v-bind="odd"
              class="form-control input-format-grey"
              style="padding-left:160px;"
            />
          </div>
          <div class="col-12 col-md-6 mt-3">
            <div class="button-gradient-yellow" style="width: 190px;">
              <label>Valor apostado</label>
            </div>
            <money
              v-model="betValue"
              :keyup="verifyBetValue(betValue)"
              v-bind="money"
              class="form-control input-format-grey"
              style="padding-left:200px;"
            />
          </div>
          <div class="col-12 col-md-6 mt-3">
            <div class="button-gradient-yellow">
              <label>Comissão</label>
            </div>
            <money
              v-model="comission"
              :keyup="verifyComission(comission)"
              v-bind="percent"
              class="form-control input-format-grey"
              style="padding-left:160px;"
            />
          </div>
          <div class="col-12 col-md-6 mt-3">
            <div class="button-gradient-green" style="width: 150px;">
              <label class="text-white">Lucro</label>
            </div>
            <money
              v-model="moneyReturn"
              v-bind="money"
              class="form-control input-format-green"
              style="padding-left:160px;"
            />
          </div>

          <div class="col-12 mt-3">
            <div class="clubedaaposta">
              <label>clubedaposta.com</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Money } from 'v-money';

export default {
  name: 'ProfitTraderCalculator',
  components: {
    Money,
  },
  data () {
    return {
      oddBack: '2.00',
      oddLay: '1.90',
      betValue: '100,00',
      comission: '6,50',
      moneyReturn: '4,92',
      percent: {
        decimal: ',',
        prefix: '',
        suffix: ' %',
        precision: 2,
        masked: false
      },
      odd: {
        decimal: '.',
        prefix: '@',
        suffix: '',
        precision: 2,
        masked: false
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '$ ',
        suffix: ' ',
        precision: 2,
        masked: false
      },
      selected: 'back',
      options: [
        { text: 'Back', value: 'back' },
        { text: 'Lay', value: 'lay' },
      ]
    }
  },
  methods: {
    verifyOddBack(item) {
      this.oddBack = item;
      let calculate = 100 - this.comission;
      if (this.selected === 'back') {
        const grossValue = this.betValue * ((this.oddBack / this.layBack) - 1)
        this.moneyReturn = calculate * grossValue / 100
      } else {
        const grossValue = this.betValue * ((this.layBack / this.oddBack) - 1)
        this.moneyReturn = calculate * grossValue / 100
      }
    },
    verifyOddLay(item) {
      this.layBack = item;
      let calculate = 100 - this.comission;
      if (this.selected === 'back') {
        const grossValue = this.betValue * ((this.oddBack / this.layBack) - 1)
        this.moneyReturn = calculate * grossValue / 100
      } else {
        const grossValue = this.betValue * ((this.layBack / this.oddBack) - 1)
        this.moneyReturn = calculate * grossValue / 100
      }
    },
    verifyBetValue(item) {
      this.betValue = item;
      let calculate = 100 - this.comission;
      if (this.selected === 'back') {
        const grossValue = this.betValue * ((this.oddBack / this.layBack) - 1)
        this.moneyReturn = calculate * grossValue / 100
      } else {
        const grossValue = this.betValue * ((this.layBack / this.oddBack) - 1)
        this.moneyReturn = calculate * grossValue / 100
      }
    },
    verifyComission(item) {
      this.comission = item;
      let calculate = 100 - this.comission;
      if (this.selected === 'back') {
        const grossValue = this.betValue * ((this.oddBack / this.layBack) - 1)
        this.moneyReturn = calculate * grossValue / 100
      } else {
        const grossValue = this.betValue * ((this.layBack / this.oddBack) - 1)
        this.moneyReturn = calculate * grossValue / 100
      }
    },
  }
}
</script>
